import { defaultTo } from 'lodash'
import { CaretakerDto, CaretakerView } from '$domain/model/caretaker/caretakerList/caretakerList.model'

const getMainQualification = (caretaker: CaretakerDto) => {
  if (caretaker.mainQualification) {
    return {
      qualificationName: defaultTo(caretaker.mainQualification.qualificationName, ''),
      specialty: defaultTo(caretaker.mainQualification.qualificationSpecialty, ''),
      type: defaultTo(caretaker.mainQualification.qualificationType, ''),
      area: defaultTo(caretaker.mainQualification.qualificationArea, ''),
    }
  }
  return {
    qualificationName: '',
    specialty: '',
    type: '',
    area: '',
  }
}

export const modelToCaretakerList = (caretakers: CaretakerDto[]): CaretakerView[] =>
  caretakers.map(caretaker => {
    return {
      caretakerId: defaultTo(caretaker.id, ''),
      name: defaultTo(caretaker.name, ''),
      distance: defaultTo(caretaker.distance, 0),
      profilePicture: defaultTo(caretaker.userImage, ''),
      mainQualification: getMainQualification(caretaker),
      price: defaultTo(caretaker.fare, ''),
      rating: defaultTo(Number(caretaker.averageRating), 0),
      locality: defaultTo(caretaker.locality, ''),
      languages: defaultTo(caretaker.languages, []),
      lastLogin: defaultTo(caretaker.lastLogin, ''),
      specialties: defaultTo(caretaker.specialties, []),
      latitude: defaultTo(caretaker.latitude, 0),
      longitude: defaultTo(caretaker.longitude, 0),
      cares: {
        elder: defaultTo(caretaker.hasAdultCare, false),
        child: defaultTo(caretaker.hasChildCare, false),
        handicapped: defaultTo(caretaker.hasDisabilityCare, false),
      },
      hasActiveProSubscription: defaultTo(caretaker.hasActiveProSubscription, false),
    }
  })



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerList/caretakerList.mapper.ts